import { IconProps } from "@/data/types"

export default function CyclingIcon({ width=32, height=32, color='#000000', className }: IconProps) {
  return (
    <div className={className}>
      <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="SVGRepo_bgCarrier" strokeWidth="0"/>
        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"/>
        <g id="SVGRepo_iconCarrier"> 
          <path d="M14 7C15.1046 7 16 6.10457 16 5C16 3.89543 15.1046 3 14 3C12.8954 3 12 3.89543 12 5C12 6.10457 12.8954 7 14 7Z" stroke={color} strokeWidth="0.72" strokeLinecap="round" strokeLinejoin="round"/> 
          <path d="M18 21C19.6569 21 21 19.6569 21 18C21 16.3431 19.6569 15 18 15C16.3431 15 15 16.3431 15 18C15 19.6569 16.3431 21 18 21Z" stroke={color} strokeWidth="0.72" strokeLinecap="round" strokeLinejoin="round"/> 
          <path d="M6 21C7.65685 21 9 19.6569 9 18C9 16.3431 7.65685 15 6 15C4.34315 15 3 16.3431 3 18C3 19.6569 4.34315 21 6 21Z" stroke={color} strokeWidth="0.72" strokeLinecap="round" strokeLinejoin="round"/> 
          <path d="M11.5 18L13 14L8.11768 12L11.1179 8.50006L14.1179 11.0001L17.6179 11.0001" stroke={color} strokeWidth="0.72" strokeLinecap="round" strokeLinejoin="round"/> 
        </g>
      </svg>
    </div>
  )
}